import { render, staticRenderFns } from "./aboutus-modal.vue?vue&type=template&id=21c9fc63"
import script from "./aboutus-modal.vue?vue&type=script&lang=js"
export * from "./aboutus-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports